import React from 'react';
import SharedProjectList from './SharedProjectList';
import './astyles/Projects.css';

const AdminProjects: React.FC = () => {
  return (
    <div className="projects-container">
      <div className="projects-header">
        <h1>Project Management</h1>
        <p>Create and manage projects, then add tasks to each project.</p>
      </div>
      
      <SharedProjectList 
        isAdmin={true}
        showCreateButton={true}
        className="projects-container"
      />
    </div>
  );
};

export default AdminProjects;